import AnalyticsApi from "@js-app/office/api/company/analytics-api";
class AnalyticsService {
  async getCurrencies(companyId, requestData) {
    return await AnalyticsApi.getCurrencies(companyId, requestData);
  }

  async getMids(companyId) {
    return await AnalyticsApi.getMids(companyId);
  }
}

export default new AnalyticsService();
